import React from 'react';

const CalendarIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.51536 12.7422L6.5524 10.8356L4.43388 9.9689L6.5524 9.10223L7.51536 7.19557L8.47833 9.10223L10.5968 9.9689L8.47833 10.8356L7.51536 12.7422ZM2.12277 14.8222C1.69907 14.8222 1.33635 14.6865 1.03462 14.4149C0.732895 14.1433 0.582031 13.8169 0.582031 13.4356V3.7289C0.582031 3.34757 0.732895 3.02112 1.03462 2.74957C1.33635 2.47801 1.69907 2.34223 2.12277 2.34223H2.89314V0.955566H4.43388V2.34223H10.5968V0.955566H12.1376V2.34223H12.908C13.3317 2.34223 13.6944 2.47801 13.9961 2.74957C14.2978 3.02112 14.4487 3.34757 14.4487 3.7289V13.4356C14.4487 13.8169 14.2978 14.1433 13.9961 14.4149C13.6944 14.6865 13.3317 14.8222 12.908 14.8222H2.12277ZM2.12277 13.4356H12.908V6.50223H2.12277V13.4356Z"
        fill="#202020"
      />
    </svg>
  );
};

export default CalendarIcon;
